import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'

const styles = theme => ({
    root: {
        border: '1px solid #B4B4A9',
        backgroundColor: 'transparent',
        position: 'absolute',
        transform: props => `rotate(${props.rotate}) scale(${props.scale})`,
        top: props => `${props.top}`,
        right: props => `${props.right}`,
        left: props => `${props.left}`,
        bottom: props => `${props.bottom}`,
        width: '900px',
        opacity: '0.3',
        height: '900px',
        zIndex: props => `${props.z}`,
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1000)]: {
            transform: props => `rotate(${props.rotate}) scale(${props.scale / 1.1})`,
            left: props => `calc(${props.left} - 100%)`,
            top: props => `calc(${props.top} - 50%)`,
            display: props => `${props.hideMobile ? 'none' : 'block'}`
        }
    },
    mobile: {
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1000)]: {
            transform: props => `rotate(${props.rotate}) scale(0.8) !important`,
            left: '-100% !important',
            top: '12% !important',
        }
    },
    hide: {
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1230)]: {
            display: 'none'
        }
    }
})

const useStyles = makeStyles(styles)

export default function Boxes({ left, right, top, bottom, rotate, scale, z, onFooter, hideMobile }) {
    const props = { left, right, rotate, scale, top, bottom, z, hideMobile }
    const classes = useStyles(props)
    return (
        <span className={clsx(classes.root, onFooter && classes.mobile, hideMobile && classes.hide)} >

        </span>
    )
}
